import React from 'react';
export function Footer() {
  return <footer className="bg-background py-16" data-id="element-70">
      <div className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-71">
        <div className="text-2xl font-serif tracking-widest uppercase text-primary" data-id="element-72">
          Aura
        </div>

        <div className="flex gap-10 text-[10px] font-sans uppercase tracking-super-wide text-secondary" data-id="element-73">
          <a href="#" className="hover:text-primary transition-colors duration-500" data-id="element-74">
            Instagram
          </a>
          <a href="#" className="hover:text-primary transition-colors duration-500" data-id="element-75">
            Facebook
          </a>
          <a href="#" className="hover:text-primary transition-colors duration-500" data-id="element-76">
            LinkedIn
          </a>
        </div>

        <div className="text-[9px] font-sans text-secondary uppercase tracking-super-wide" data-id="element-77">
          &copy; {new Date().getFullYear()} Aura. All rights reserved.
        </div>
      </div>
    </footer>;
}